import React from 'react';
import postC from './PostCard.module.css';
import { Eyeglasses } from 'phosphor-react';

export const PostCard = ({ post }) => {
  return (
    <div className={postC.postCard}>
      <img src={post.coverImage} alt={post.title} />
      <div className={postC.container}>
        <div className={postC.description}>
          <h2>{post.title}</h2>
          <p>{post.description}</p>
        </div>
        <div className={postC.info}>
          <p className={postC.date}>{post.date}</p>
          <div className={postC.views}>
            <Eyeglasses weight="light" className={postC.icon} />
            <span>{(post.views ?? 0).toLocaleString()} views</span>
          </div>
        </div>
      </div>
    </div>
  );
};
